import { getConfig } from "../../../config/runtimeConfig";
import { ACCESS_TOKEN } from "../../Contants";
import { DEFAULT_ENDPOINT } from "./client";
import { PollyTtsOrchestrator } from "./orchestrator";

const sharedOrchestrator = new PollyTtsOrchestrator();

function resolveEndpoint() {
  try {
    return getConfig().POLLY_API_URL || DEFAULT_ENDPOINT;
  } catch {
    return DEFAULT_ENDPOINT;
  }
}

export function isPollyTtsSupported() {
  return typeof Audio !== "undefined";
}

/** Gateway TTS requires a logged-in accessToken. */
export function isPollyTtsAuthorized() {
  return Boolean(localStorage.getItem(ACCESS_TOKEN));
}

export function unlockPollyTts() {
  return sharedOrchestrator.unlockAutoplay();
}

export function cancelPollyTts() {
  sharedOrchestrator.cancel();
}

/**
 * Shared Polly speak entry — cancels any in-flight speech first.
 * @param {{ text: string, language: string, rate?: string, shouldContinue?: () => boolean }} options
 */
export function speakWithPolly(options) {
  return sharedOrchestrator.speak({
    ...options,
    endpoint: resolveEndpoint(),
  });
}

export { DEFAULT_ENDPOINT };
export { hasSpeakableContent } from "./orchestrator";
export {
  getEpubVisiblePageText,
  waitForEpubLayoutSettle,
} from "./epubVisibleText";
